module.exports = __webpack_public_path__ + "img/10_SAK.0a9b2229.jpg";